import { Injectable } from '@angular/core';
import {FormArray, FormControl, FormGroup, Validators} from '@angular/forms';
import {ExportResquestForm, OntologyFormType} from '@gnv-shared/types';
import {PeriodicityType} from '@gnv-shared/models';
import {
  InformationMessageDestinationType
} from '../../models/information-messages/information-message-destination-type';
import { ReportFrequency } from 'swagger-gen/gnvert-secured/models/report-frequency';
import { ConfiguredMessageTarget } from 'swagger-gen/web-secured/models/configured-message-target';

@Injectable({
  providedIn: 'root'
})
export class ExportRequestFormService {
  private form!: FormGroup<ExportResquestForm>;

  constructor() {
    this.initForm();
  }

  public getForm(): FormGroup<ExportResquestForm> {
    return this.form
  }

  public setDestinationFormValues(
    selectedDestinationValues: string[],
  ) {
    if (selectedDestinationValues.length) {
      switch (this.form.controls.destinationType.value) {
        case InformationMessageDestinationType.DIFFUSION_LIST: {
          this.form.controls.destination.setValue({diffusionList: {diffusionListUids: selectedDestinationValues}});
          break;
        }
        case InformationMessageDestinationType.ROLE: {
          this.form.controls.destination.setValue({role: {roleUids: selectedDestinationValues}});
          break;
        }
        case InformationMessageDestinationType.USER: {
          this.form.controls.destination.setValue({user: {userUids: selectedDestinationValues}});
          break;
        }
        default: {
          this.form.controls.destination.setValue(null);
          break;
        }
      }
    } else {
      this.form.controls.destination.setValue(null);
    }
  }

  private initForm() {
    this.form = new FormGroup({
      name: new FormControl<string>("", { validators: [Validators.required], nonNullable: true }),
      periodicityType: new FormControl<PeriodicityType>(PeriodicityType.DATE, { validators: [Validators.required] }),
      frequency: new FormControl<ReportFrequency | null>(null, { nonNullable: true, updateOn: 'blur' }),
      destination: new FormControl<ConfiguredMessageTarget | null>(null, { validators: [Validators.required] }),
      destinationType: new FormControl<InformationMessageDestinationType | null>(null, { validators: [Validators.required] }),
      destinationValues: new FormControl<string[]>([], { validators: [Validators.required], nonNullable: true }),
      withoutHeaders: new FormControl(false, { nonNullable: true }),
      ontologyForms: new FormArray<FormGroup<OntologyFormType>>([]),
    });
  }


}
